/* eslint-disable react/prop-types */
import { PropsWithChildren, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface UaGateProps {
  children: React.ReactNode;
}

const REDIRECT_ORIGIN = 'https://1roomauction.nippon-rebax.co.jp';

const detectTargetUrl = (
  pathname: string,
  search: string,
  hash: string
): string | null => {
  const ua = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  if (!isIOS && !isAndroid) return null;
  return `${REDIRECT_ORIGIN}${pathname}${search}${hash}`;
};

export const UaGate: React.FC<PropsWithChildren<UaGateProps>> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const skipPaths = new Set<string>(['/healthz']);
    if (skipPaths.has(location.pathname)) return;

    const targetUrl = detectTargetUrl(location.pathname, location.search, location.hash);
    if (!targetUrl) return;

    const isExternal = !targetUrl.startsWith(window.location.origin);
    if (isExternal) {
      window.location.replace(targetUrl);
      return;
    }

    navigate(targetUrl, {
      replace: true,
      state: { from: location.pathname } as { from: string },
    });
  }, [location.pathname, location.search, location.hash, navigate]);

  return <>{children}</>;
};
